interface PageParams {
    pathname: string;
    generalKeys: string[];
    tabs: string[];
    theme?: string;
    sites: string[];
}

export const pageParams: PageParams = {
    pathname: 'smart-home-panel-3',
    generalKeys: ['product_shp32'],
    tabs: ['product', 'Spec', 'support'],
    theme: 'black',
    sites: ['us'],
};

export const pathname = pageParams.pathname;
export const generalKeys = pageParams.generalKeys;
export const tabs = pageParams.tabs;
export const theme = pageParams.theme;
export const sites = pageParams.sites;
